"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandBannerController = void 0;
var ExpandBannerController = /** @class */ (function () {
    function ExpandBannerController(buttonRowBlock) {
        this.buttonRowBlock = buttonRowBlock;
        this.attachEvents();
    }
    ExpandBannerController.expandBanners = function (element) {
        var _a;
        // Reveal all hidden banners
        document.querySelectorAll(ExpandBannerController.contentQuerySelector).forEach(function (element) {
            element.classList.remove(ExpandBannerController.isCollapsedClassName);
        });
        // Hide the show more button
        (_a = element
            .querySelector(ExpandBannerController.buttonRowQuerySelector)) === null || _a === void 0 ? void 0 : _a.classList.add(ExpandBannerController.isCollapsedClassName);
    };
    ExpandBannerController.prototype.attachEvents = function () {
        var expandTextBlock = this.buttonRowBlock.querySelector(ExpandBannerController.expandBannerQuerySelector);
        expandTextBlock === null || expandTextBlock === void 0 ? void 0 : expandTextBlock.addEventListener('click', function (event) {
            var target = event.target;
            var targetSection = target.closest(ExpandBannerController.componentWrapperQuerySelector);
            targetSection && ExpandBannerController.expandBanners(targetSection);
        });
    };
    ExpandBannerController.componentWrapperQuerySelector = '.js-banner-cluster';
    ExpandBannerController.buttonRowQuerySelector = '.js-button-container';
    ExpandBannerController.expandBannerQuerySelector = '.js-expand-category';
    ExpandBannerController.contentQuerySelector = '.js-banner-element';
    ExpandBannerController.isCollapsedClassName = 'is-collapsed';
    return ExpandBannerController;
}());
exports.ExpandBannerController = ExpandBannerController;
